import { PaisTelefone } from '../models/pais-telefone.model';

export const ISO_PAIS_PADRAO = 'br';
export const DDI_BRASIL = '55';
export const URL_BANDEIRAS = 'https://flagcdn.com/w40';
export const MAX_DIGITOS_TELEFONE = 15;
export const MIN_DIGITOS_TELEFONE_INTERNACIONAL = 4;
export const MIN_DIGITOS_TELEFONE_BRASIL = 10;
export const MAX_DIGITOS_TELEFONE_BRASIL = 11;

export const PAISES_TELEFONE: PaisTelefone[] = [
  { iso: 'af', nome: 'Afghanistan', codigo: '+93' },
  { iso: 'ax', nome: 'Åland Islands', codigo: '+358' },
  { iso: 'al', nome: 'Albania', codigo: '+355' },
  { iso: 'dz', nome: 'Algeria', codigo: '+213' },
  { iso: 'as', nome: 'American Samoa', codigo: '+1-684' },
  { iso: 'ad', nome: 'Andorra', codigo: '+376' },
  { iso: 'ao', nome: 'Angola', codigo: '+244' },
  { iso: 'ai', nome: 'Anguilla', codigo: '+1-264' },
  { iso: 'ag', nome: 'Antigua and Barbuda', codigo: '+1-268' },
  { iso: 'ar', nome: 'Argentina', codigo: '+54' },
  { iso: 'am', nome: 'Armenia', codigo: '+374' },
  { iso: 'aw', nome: 'Aruba', codigo: '+297' },
  { iso: 'au', nome: 'Australia', codigo: '+61' },
  { iso: 'at', nome: 'Austria', codigo: '+43' },
  { iso: 'az', nome: 'Azerbaijan', codigo: '+994' },
  { iso: 'bs', nome: 'Bahamas', codigo: '+1-242' },
  { iso: 'bh', nome: 'Bahrain', codigo: '+973' },
  { iso: 'bd', nome: 'Bangladesh', codigo: '+880' },
  { iso: 'bb', nome: 'Barbados', codigo: '+1-246' },
  { iso: 'by', nome: 'Belarus', codigo: '+375' },
  { iso: 'be', nome: 'Belgium', codigo: '+32' },
  { iso: 'bz', nome: 'Belize', codigo: '+501' },
  { iso: 'bj', nome: 'Benin', codigo: '+229' },
  { iso: 'bm', nome: 'Bermuda', codigo: '+1-441' },
  { iso: 'bt', nome: 'Bhutan', codigo: '+975' },
  { iso: 'bo', nome: 'Bolivia', codigo: '+591' },
  { iso: 'ba', nome: 'Bosnia and Herzegovina', codigo: '+387' },
  { iso: 'bw', nome: 'Botswana', codigo: '+267' },
  { iso: 'br', nome: 'Brazil', codigo: '+55' },
  { iso: 'io', nome: 'British Indian Ocean Territory', codigo: '+246' },
  { iso: 'vg', nome: 'British Virgin Islands', codigo: '+1-284' },
  { iso: 'bn', nome: 'Brunei', codigo: '+673' },
  { iso: 'bg', nome: 'Bulgaria', codigo: '+359' },
  { iso: 'bf', nome: 'Burkina Faso', codigo: '+226' },
  { iso: 'bi', nome: 'Burundi', codigo: '+257' },
  { iso: 'kh', nome: 'Cambodia', codigo: '+855' },
  { iso: 'cm', nome: 'Cameroon', codigo: '+237' },
  { iso: 'ca', nome: 'Canada', codigo: '+1' },
  { iso: 'cv', nome: 'Cape Verde', codigo: '+238' },
  { iso: 'bq', nome: 'Caribbean Netherlands', codigo: '+599' },
  { iso: 'ky', nome: 'Cayman Islands', codigo: '+1-345' },
  { iso: 'cf', nome: 'Central African Republic', codigo: '+236' },
  { iso: 'td', nome: 'Chad', codigo: '+235' },
  { iso: 'cl', nome: 'Chile', codigo: '+56' },
  { iso: 'cn', nome: 'China', codigo: '+86' },
  { iso: 'cx', nome: 'Christmas Island', codigo: '+61' },
  { iso: 'cc', nome: 'Cocos (Keeling) Islands', codigo: '+61' },
  { iso: 'co', nome: 'Colombia', codigo: '+57' },
  { iso: 'km', nome: 'Comoros', codigo: '+269' },
  { iso: 'cg', nome: 'Congo', codigo: '+242' },
  { iso: 'cd', nome: 'Congo (DRC)', codigo: '+243' },
  { iso: 'ck', nome: 'Cook Islands', codigo: '+682' },
  { iso: 'cr', nome: 'Costa Rica', codigo: '+506' },
  { iso: 'ci', nome: "Côte d'Ivoire", codigo: '+225' },
  { iso: 'hr', nome: 'Croatia', codigo: '+385' },
  { iso: 'cu', nome: 'Cuba', codigo: '+53' },
  { iso: 'cw', nome: 'Curaçao', codigo: '+599' },
  { iso: 'cy', nome: 'Cyprus', codigo: '+357' },
  { iso: 'cz', nome: 'Czech Republic', codigo: '+420' },
  { iso: 'dk', nome: 'Denmark', codigo: '+45' },
  { iso: 'dj', nome: 'Djibouti', codigo: '+253' },
  { iso: 'dm', nome: 'Dominica', codigo: '+1-767' },
  { iso: 'do', nome: 'Dominican Republic', codigo: '+1-809' },
  { iso: 'ec', nome: 'Ecuador', codigo: '+593' },
  { iso: 'eg', nome: 'Egypt', codigo: '+20' },
  { iso: 'sv', nome: 'El Salvador', codigo: '+503' },
  { iso: 'gq', nome: 'Equatorial Guinea', codigo: '+240' },
  { iso: 'er', nome: 'Eritrea', codigo: '+291' },
  { iso: 'ee', nome: 'Estonia', codigo: '+372' },
  { iso: 'sz', nome: 'Eswatini', codigo: '+268' },
  { iso: 'et', nome: 'Ethiopia', codigo: '+251' },
  { iso: 'fk', nome: 'Falkland Islands', codigo: '+500' },
  { iso: 'fo', nome: 'Faroe Islands', codigo: '+298' },
  { iso: 'fj', nome: 'Fiji', codigo: '+679' },
  { iso: 'fi', nome: 'Finland', codigo: '+358' },
  { iso: 'fr', nome: 'France', codigo: '+33' },
  { iso: 'gf', nome: 'French Guiana', codigo: '+594' },
  { iso: 'pf', nome: 'French Polynesia', codigo: '+689' },
  { iso: 'ga', nome: 'Gabon', codigo: '+241' },
  { iso: 'gm', nome: 'Gambia', codigo: '+220' },
  { iso: 'ge', nome: 'Georgia', codigo: '+995' },
  { iso: 'de', nome: 'Germany', codigo: '+49' },
  { iso: 'gh', nome: 'Ghana', codigo: '+233' },
  { iso: 'gi', nome: 'Gibraltar', codigo: '+350' },
  { iso: 'gr', nome: 'Greece', codigo: '+30' },
  { iso: 'gl', nome: 'Greenland', codigo: '+299' },
  { iso: 'gd', nome: 'Grenada', codigo: '+1-473' },
  { iso: 'gp', nome: 'Guadeloupe', codigo: '+590' },
  { iso: 'gu', nome: 'Guam', codigo: '+1-671' },
  { iso: 'gt', nome: 'Guatemala', codigo: '+502' },
  { iso: 'gg', nome: 'Guernsey', codigo: '+44' },
  { iso: 'gn', nome: 'Guinea', codigo: '+224' },
  { iso: 'gw', nome: 'Guinea-Bissau', codigo: '+245' },
  { iso: 'gy', nome: 'Guyana', codigo: '+592' },
  { iso: 'ht', nome: 'Haiti', codigo: '+509' },
  { iso: 'hn', nome: 'Honduras', codigo: '+504' },
  { iso: 'hk', nome: 'Hong Kong', codigo: '+852' },
  { iso: 'hu', nome: 'Hungary', codigo: '+36' },
  { iso: 'is', nome: 'Iceland', codigo: '+354' },
  { iso: 'in', nome: 'India', codigo: '+91' },
  { iso: 'id', nome: 'Indonesia', codigo: '+62' },
  { iso: 'ir', nome: 'Iran', codigo: '+98' },
  { iso: 'iq', nome: 'Iraq', codigo: '+964' },
  { iso: 'ie', nome: 'Ireland', codigo: '+353' },
  { iso: 'im', nome: 'Isle of Man', codigo: '+44' },
  { iso: 'il', nome: 'Israel', codigo: '+972' },
  { iso: 'it', nome: 'Italy', codigo: '+39' },
  { iso: 'jm', nome: 'Jamaica', codigo: '+1-876' },
  { iso: 'jp', nome: 'Japan', codigo: '+81' },
  { iso: 'je', nome: 'Jersey', codigo: '+44' },
  { iso: 'jo', nome: 'Jordan', codigo: '+962' },
  { iso: 'kz', nome: 'Kazakhstan', codigo: '+7' },
  { iso: 'ke', nome: 'Kenya', codigo: '+254' },
  { iso: 'ki', nome: 'Kiribati', codigo: '+686' },
  { iso: 'xk', nome: 'Kosovo', codigo: '+383' },
  { iso: 'kw', nome: 'Kuwait', codigo: '+965' },
  { iso: 'kg', nome: 'Kyrgyzstan', codigo: '+996' },
  { iso: 'la', nome: 'Laos', codigo: '+856' },
  { iso: 'lv', nome: 'Latvia', codigo: '+371' },
  { iso: 'lb', nome: 'Lebanon', codigo: '+961' },
  { iso: 'ls', nome: 'Lesotho', codigo: '+266' },
  { iso: 'lr', nome: 'Liberia', codigo: '+231' },
  { iso: 'ly', nome: 'Libya', codigo: '+218' },
  { iso: 'li', nome: 'Liechtenstein', codigo: '+423' },
  { iso: 'lt', nome: 'Lithuania', codigo: '+370' },
  { iso: 'lu', nome: 'Luxembourg', codigo: '+352' },
  { iso: 'mo', nome: 'Macau', codigo: '+853' },
  { iso: 'mg', nome: 'Madagascar', codigo: '+261' },
  { iso: 'mw', nome: 'Malawi', codigo: '+265' },
  { iso: 'my', nome: 'Malaysia', codigo: '+60' },
  { iso: 'mv', nome: 'Maldives', codigo: '+960' },
  { iso: 'ml', nome: 'Mali', codigo: '+223' },
  { iso: 'mt', nome: 'Malta', codigo: '+356' },
  { iso: 'mh', nome: 'Marshall Islands', codigo: '+692' },
  { iso: 'mq', nome: 'Martinique', codigo: '+596' },
  { iso: 'mr', nome: 'Mauritania', codigo: '+222' },
  { iso: 'mu', nome: 'Mauritius', codigo: '+230' },
  { iso: 'yt', nome: 'Mayotte', codigo: '+262' },
  { iso: 'mx', nome: 'Mexico', codigo: '+52' },
  { iso: 'fm', nome: 'Micronesia', codigo: '+691' },
  { iso: 'md', nome: 'Moldova', codigo: '+373' },
  { iso: 'mc', nome: 'Monaco', codigo: '+377' },
  { iso: 'mn', nome: 'Mongolia', codigo: '+976' },
  { iso: 'me', nome: 'Montenegro', codigo: '+382' },
  { iso: 'ms', nome: 'Montserrat', codigo: '+1-664' },
  { iso: 'ma', nome: 'Morocco', codigo: '+212' },
  { iso: 'mz', nome: 'Mozambique', codigo: '+258' },
  { iso: 'mm', nome: 'Myanmar', codigo: '+95' },
  { iso: 'na', nome: 'Namibia', codigo: '+264' },
  { iso: 'nr', nome: 'Nauru', codigo: '+674' },
  { iso: 'np', nome: 'Nepal', codigo: '+977' },
  { iso: 'nl', nome: 'Netherlands', codigo: '+31' },
  { iso: 'nc', nome: 'New Caledonia', codigo: '+687' },
  { iso: 'nz', nome: 'New Zealand', codigo: '+64' },
  { iso: 'ni', nome: 'Nicaragua', codigo: '+505' },
  { iso: 'ne', nome: 'Niger', codigo: '+227' },
  { iso: 'ng', nome: 'Nigeria', codigo: '+234' },
  { iso: 'nu', nome: 'Niue', codigo: '+683' },
  { iso: 'nf', nome: 'Norfolk Island', codigo: '+672' },
  { iso: 'kp', nome: 'North Korea', codigo: '+850' },
  { iso: 'mk', nome: 'North Macedonia', codigo: '+389' },
  { iso: 'mp', nome: 'Northern Mariana Islands', codigo: '+1-670' },
  { iso: 'no', nome: 'Norway', codigo: '+47' },
  { iso: 'om', nome: 'Oman', codigo: '+968' },
  { iso: 'pk', nome: 'Pakistan', codigo: '+92' },
  { iso: 'pw', nome: 'Palau', codigo: '+680' },
  { iso: 'ps', nome: 'Palestine', codigo: '+970' },
  { iso: 'pa', nome: 'Panama', codigo: '+507' },
  { iso: 'pg', nome: 'Papua New Guinea', codigo: '+675' },
  { iso: 'py', nome: 'Paraguay', codigo: '+595' },
  { iso: 'pe', nome: 'Peru', codigo: '+51' },
  { iso: 'ph', nome: 'Philippines', codigo: '+63' },
  { iso: 'pl', nome: 'Poland', codigo: '+48' },
  { iso: 'pt', nome: 'Portugal', codigo: '+351' },
  { iso: 'pr', nome: 'Puerto Rico', codigo: '+1-787' },
  { iso: 'qa', nome: 'Qatar', codigo: '+974' },
  { iso: 're', nome: 'Réunion', codigo: '+262' },
  { iso: 'ro', nome: 'Romania', codigo: '+40' },
  { iso: 'ru', nome: 'Russia', codigo: '+7' },
  { iso: 'rw', nome: 'Rwanda', codigo: '+250' },
  { iso: 'bl', nome: 'Saint Barthélemy', codigo: '+590' },
  { iso: 'sh', nome: 'Saint Helena', codigo: '+290' },
  { iso: 'kn', nome: 'Saint Kitts and Nevis', codigo: '+1-869' },
  { iso: 'lc', nome: 'Saint Lucia', codigo: '+1-758' },
  { iso: 'mf', nome: 'Saint Martin', codigo: '+590' },
  { iso: 'pm', nome: 'Saint Pierre and Miquelon', codigo: '+508' },
  { iso: 'vc', nome: 'Saint Vincent and the Grenadines', codigo: '+1-784' },
  { iso: 'ws', nome: 'Samoa', codigo: '+685' },
  { iso: 'sm', nome: 'San Marino', codigo: '+378' },
  { iso: 'st', nome: 'São Tomé and Príncipe', codigo: '+239' },
  { iso: 'sa', nome: 'Saudi Arabia', codigo: '+966' },
  { iso: 'sn', nome: 'Senegal', codigo: '+221' },
  { iso: 'rs', nome: 'Serbia', codigo: '+381' },
  { iso: 'sc', nome: 'Seychelles', codigo: '+248' },
  { iso: 'sl', nome: 'Sierra Leone', codigo: '+232' },
  { iso: 'sg', nome: 'Singapore', codigo: '+65' },
  { iso: 'sx', nome: 'Sint Maarten', codigo: '+1-721' },
  { iso: 'sk', nome: 'Slovakia', codigo: '+421' },
  { iso: 'si', nome: 'Slovenia', codigo: '+386' },
  { iso: 'sb', nome: 'Solomon Islands', codigo: '+677' },
  { iso: 'so', nome: 'Somalia', codigo: '+252' },
  { iso: 'za', nome: 'South Africa', codigo: '+27' },
  { iso: 'kr', nome: 'South Korea', codigo: '+82' },
  { iso: 'ss', nome: 'South Sudan', codigo: '+211' },
  { iso: 'es', nome: 'Spain', codigo: '+34' },
  { iso: 'lk', nome: 'Sri Lanka', codigo: '+94' },
  { iso: 'sd', nome: 'Sudan', codigo: '+249' },
  { iso: 'sr', nome: 'Suriname', codigo: '+597' },
  { iso: 'sj', nome: 'Svalbard and Jan Mayen', codigo: '+47' },
  { iso: 'se', nome: 'Sweden', codigo: '+46' },
  { iso: 'ch', nome: 'Switzerland', codigo: '+41' },
  { iso: 'sy', nome: 'Syria', codigo: '+963' },
  { iso: 'tw', nome: 'Taiwan', codigo: '+886' },
  { iso: 'tj', nome: 'Tajikistan', codigo: '+992' },
  { iso: 'tz', nome: 'Tanzania', codigo: '+255' },
  { iso: 'th', nome: 'Thailand', codigo: '+66' },
  { iso: 'tl', nome: 'Timor-Leste', codigo: '+670' },
  { iso: 'tg', nome: 'Togo', codigo: '+228' },
  { iso: 'tk', nome: 'Tokelau', codigo: '+690' },
  { iso: 'to', nome: 'Tonga', codigo: '+676' },
  { iso: 'tt', nome: 'Trinidad and Tobago', codigo: '+1-868' },
  { iso: 'tn', nome: 'Tunisia', codigo: '+216' },
  { iso: 'tr', nome: 'Turkey', codigo: '+90' },
  { iso: 'tm', nome: 'Turkmenistan', codigo: '+993' },
  { iso: 'tc', nome: 'Turks and Caicos Islands', codigo: '+1-649' },
  { iso: 'tv', nome: 'Tuvalu', codigo: '+688' },
  { iso: 'vi', nome: 'U.S. Virgin Islands', codigo: '+1-340' },
  { iso: 'ug', nome: 'Uganda', codigo: '+256' },
  { iso: 'ua', nome: 'Ukraine', codigo: '+380' },
  { iso: 'ae', nome: 'United Arab Emirates', codigo: '+971' },
  { iso: 'gb', nome: 'United Kingdom', codigo: '+44' },
  { iso: 'us', nome: 'United States', codigo: '+1' },
  { iso: 'uy', nome: 'Uruguay', codigo: '+598' },
  { iso: 'uz', nome: 'Uzbekistan', codigo: '+998' },
  { iso: 'vu', nome: 'Vanuatu', codigo: '+678' },
  { iso: 'va', nome: 'Vatican City', codigo: '+39' },
  { iso: 've', nome: 'Venezuela', codigo: '+58' },
  { iso: 'vn', nome: 'Vietnam', codigo: '+84' },
  { iso: 'wf', nome: 'Wallis and Futuna', codigo: '+681' },
  { iso: 'eh', nome: 'Western Sahara', codigo: '+212' },
  { iso: 'ye', nome: 'Yemen', codigo: '+967' },
  { iso: 'zm', nome: 'Zambia', codigo: '+260' },
  { iso: 'zw', nome: 'Zimbabwe', codigo: '+263' }
];
